<div class="topbar-item d-none d-sm-flex">
  <button (click)="layout.openCustomizer()" class="topbar-link" type="button">
    <ng-icon name="tablerSettings" class="icon-spin fs-24"/>
  </button>
</div>
